export default theme => ({
  item: {
    cursor: 'pointer',
    color: '#c9c9c9',
    fontSize: 13,
    padding: '0 5px',
    '&:hover, &:hover span': {
      color: '#888'
    }
  },
  itemIcon: {
    color: '#c9c9c9',
    paddingRight: 3
  },

  approve: {
    '&:hover, &:hover span, &.selected, &.selected span': {
      color: '#b5d722'
    }
  },
  reject: {
    '&:hover, &:hover span, &.selected, &.selected span': {
      color: '#fd8f83'
    }
  },
});

